export default "__VITE_PUBLIC_ASSET__d9542212__"